import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQSection = () => {
  const { t, i18n } = useTranslation();

  const faqs = [
    {
      question: t('faq.questions.privacy.question'),
      answer: t('faq.questions.privacy.answer'),
    },
    {
      question: t('faq.questions.audioFormats.question'),
      answer: t('faq.questions.audioFormats.answer'),
    },
    {
      question: t('faq.questions.voiceMemos.question'),
      answer: t('faq.questions.voiceMemos.answer'),
    },
    {
      question: t('faq.questions.devices.question'),
      answer: t('faq.questions.devices.answer'),
    },
    {
      question: t('faq.questions.languages.question'),
      answer: t('faq.questions.languages.answer'),
    },
  ];

  return (
    <div
      id="faq"
      style={{ background: 'var(--v2-bg)', color: 'var(--v2-ink)', position: 'relative', zIndex: 2 }}
      className="py-24 px-4"
    >
      <div style={{ maxWidth: '820px', margin: '0 auto' }}>
        <div className="text-center mb-12">
          <h2
            style={{
              fontSize: 'clamp(26px, 3.5vw, 38px)',
              fontWeight: 800,
              color: 'var(--v2-ink)',
              marginBottom: '10px',
            }}
          >
            {t('faq.title')}
          </h2>
          <p style={{ fontSize: '16px', color: 'var(--v2-ink-muted)' }}>
            {t('faq.subtitle', 'Have questions about Notely? Find answers below.')}
          </p>
        </div>

        <Accordion type="single" collapsible defaultValue="item-0">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              style={{
                border: '1px solid var(--v2-line)',
                borderRadius: '14px',
                marginBottom: '12px',
                overflow: 'hidden',
                background: 'var(--v2-card)',
              }}
              className="px-0"
            >
              <AccordionTrigger
                style={{ color: 'var(--v2-ink)', fontWeight: 600, padding: '18px 20px' }}
                className="hover:no-underline text-left data-[state=open]:text-primary"
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent
                style={{ color: 'var(--v2-ink-muted)', padding: '0 20px 18px', lineHeight: 1.65 }}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-8" style={{ color: 'var(--v2-ink-muted)' }}>
          {t('faq.moreQuestions')}{' '}
          <a href={`/${i18n.language || 'en'}/contact`} style={{ color: 'var(--v2-primary)', textDecoration: 'none', fontWeight: 600 }}>
            {t('faq.contactSupport')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
